Vue.component('spark-kiosk-sites', {
    props: ['site'],

    data() {
        return {
            sites: [],
            showingSite: false,
            deleted: false,
            loading: true
        };
    },
    created() {
        var self = this;

        this.getSites();
        console.log("HI");
    },

    methods: {
        /**
         * Get all of the available subscription plans.
         */
        getSites() {

            axios.get('/admin/sites')
                .then(response => {
                    this.sites = response.data;
                    this.loading= false
                });

        },

        showSite(site) {

            history.pushState(null, null, '#/site/' + site.id);
            this.loadSite(site);
        },
        newSite() {
            history.pushState(null, null, '#/site/');
            this.showingSite = true;
        },

        /**
         * Load the user profile for the given user.
         */
        loadSite(site) {
            this.$emit('showSite', site.id);

            this.showingSite = true;
        },
        showIndex(){
            this.showingSite = false;
        },

        deleteSite(site){
            axios.delete('/admin/site/'+site.id)
                .then(response => {
                    this.sites = response.data;
                    this.deleted = true;
                    this.getSites();
                });

        }


        /*

        /**
         * Show the user profile for the given user.
         *
        showSite(user) {
            history.pushState(null, null, '#/users/' + user.id);

            this.loadProfile(user);
        },


        /**
         * Load the user profile for the given user.
         *
        loadProfile(user) {
            this.$emit('showUserProfile', user.id);

            this.showingUserProfile = true;
        }
        */
    }
});






